import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { BaseEnvironment, ENVIRONMENT } from '@warema/shared/models';
import { Observable } from 'rxjs';

@Injectable({
    providedIn: 'root',
})
export class AssetCachingInterceptor implements HttpInterceptor {
    private readonly _environment = inject<BaseEnvironment>(ENVIRONMENT);

    private readonly _basePaths = ['assets/', 'shared-assets/', 'media/'];

    public intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
        const checkPaths = [] as Array<string>;
        for (const path of this._basePaths) {
            checkPaths.push(path, '.' + path, './' + path);
        }

        const urlMatches = checkPaths.some(x => req.urlWithParams.startsWith(x));
        if (req.method === 'GET' && urlMatches) {
            const clone = req.clone({
                // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
                setParams: {
                    ver:
                        this._environment.currentReleasedCommitSHA?.substring(0, 7) ||
                        new Date().toISOString().split('T')[0].toString(),
                },
            });
            return next.handle(clone);
        }
        return next.handle(req);
    }
}
